import {
    FETCH_CATEGORIES,
    SET_ACTIVE_CATEGORY,
    SET_ACTIVE_LEAF_CATEGORY,
    SET_CATEGORIES_VISIBILITY,
    SET_IS_FETCHING_CATEGORIES,
} from 'reducers/actions-types';
import { dispatchError } from 'reducers/helpers';
import { categories as categoriesURL, category as categoryURL } from 'constants/api-urls';
import axios from 'axios';

const fetchRequests = {};

const actions = Object.freeze({
    /**
     *
     * @param {ICategory | null} category
     * @return {function(*=, *): *}
     */
    fetchCategories({ category } = {}) {
        return (dispatch, getState) => {
            const { cooperative } = getState().router;
            // If no cache is available, fetch the categories
            const url = category ? categoryURL(category.id, cooperative) : categoriesURL(cooperative);

            if (!fetchRequests[url]) {
                dispatch({
                    category,
                    type: SET_IS_FETCHING_CATEGORIES,
                });

                fetchRequests[url] = axios.get(url)
                    .then(
                        /**
                         * @param {ICategory[]} categories
                         */
                        ({ data: categories }) => {
                            dispatch({ type: FETCH_CATEGORIES, categories, category });

                            if (!categories.length) {
                                dispatchError(dispatch, null, {
                                    url: url,
                                });
                            }

                            return categories;
                        })
                    .catch(e => {
                        if (e.status === 404) {
                            return Promise.reject(e);
                        }

                        dispatchError(dispatch, e, {
                            url: url,
                            description: (e.message),
                            reloadButton: true,
                        });

                        return Promise.resolve({});
                    });
            }

            return fetchRequests[url];
        };
    },

    /**
     * Set the visibility for the categories list
     * @param {boolean} isVisible
     * @return {{type: *, isCategorylistVisible: *}}
     */
    setCategoriesVisibility({ isVisible }) {
        return { type: SET_CATEGORIES_VISIBILITY, isCategorylistVisible: isVisible };
    },

    /**
     * Set active category
     * @param {ICategory} category
     * @return {{type: *, category: ICategory}}
     */
    setActiveCategory({ category }) {
        return { type: SET_ACTIVE_CATEGORY, category };
    },

    /**
     * The leaf categories are the ones that have no children nodes
     * @param {ICategory} category
     * @return {{type: *, category: ICategory}}
     */
    setActiveLeafCategory({ category }) {
        return { type: SET_ACTIVE_LEAF_CATEGORY, category };
    },
});

export default actions;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/categories/actions.js